<template>
	<el-dialog title="Modify Plan"
						 :visible.sync="$parent.dialog.plan"
						 width="90%"
						 :close-on-click-modal="false"
						 :append-to-body="false">




		<div class="row">

			<div class="col-md-10 offset-md-1 mb-2 mt-4">

				<div class="text-center" v-if="payment.statusId !== 'PS_CANCELLED'">
					<h2 class="mb-2">Your Current Membership:</h2><h2 v-html="payment.productName"></h2><h2 v-html="payment.passCards"></h2>
					<h5> If you wish to cancel your membership scroll to the bottom of this page to do so.<br />Consider purchasing a class card if you would still like to visit us!</h5>
					<!--<h5>{{payment.studio}}</h5>-->
				</div>

				<el-alert type="warning" v-if="payment.statusId === 'PS_ON_HOLD'" class="text-center mb-3" :closable="false">
					<div class="mb-3" v-html="config.onHold.replace('{{nextpayment}}', payment.nextPayment)"></div>
					<el-radio data-vv-name="next payment date" v-model="changeNow" :label="true" v-validate="'required'">Change Now</el-radio>
					<el-radio data-vv-name="next payment date" v-model="changeNow" :label="false" v-validate="'required'">Change On {{payment.nextPayment}}</el-radio>
				</el-alert>


			<template v-if="planSelection === 'standard'">

				<div class="container">

					<div class="card mb-3" v-show="user.acceptText === 'MemSpecial' && payment.statusId === 'PS_CANCELLED'">
						<div class="ribbon-wrapper">
							<div class="ribbon green">
								SPECIAL
							</div>
						</div>
						<div class="card-body text-center">
							<h3 class="mb-3">
								Special Offer for Current Members!<br /><br /> Prepay up to 12 months and receive a discount!<br />10% off for 1-3 months, 20% off for 4-6 months, 30% off for 7-12 months
							</h3>
							{{selectedPlan.planType}}
							<h4>
								<select v-model="numMonths">
									<option disabled value="">select</option>
									<option>1</option>
									<option>2</option>
									<option>3</option>
									<option>4</option>
									<option>5</option>
									<option>6</option>
									<option>7</option>
									<option>8</option>
									<option>9</option>
									<option>10</option>
									<option>11</option>
									<option>12</option>
								</select>
							</h4><br />
							<h4>Months Selected: {{ numMonths }}<br /> Discount: {{calcDiscount}}<br />Payment: ${{ formatPrice(calcPrice) }} </h4>

							<div>
								<el-button class="mb-3 ml-3 mr-3" @click="submit" type="primary"> Purchase {{numMonths}} for  ${{ formatPrice(calcPrice) }}!</el-button>
							</div>

						</div>
					</div>


				</div>

				<div class="container">

					<div class="card mb-3" v-show="user.acceptText === 'Test' && payment.statusId === 'PS_CANCELLED'">
						<div class="ribbon-wrapper">
							<div class="ribbon green">
								SPECIAL
							</div>
						</div>
						<div class="card-body text-center">
							<h3 class="mb-3">
								Special Offer for Previous Members!
							</h3>
							<h5 class="mb-3">
								Cancel any time with 30 days notice<br />
								After special, membership <strong>continues</strong> as Unlimited Month to Month for $119/month <strong>if not cancelled</strong>
							</h5>
						</div>
					</div>

					<div class="row justify-content-md-center" v-show="user.acceptText === 'Test'">

						<div class="row card-deck mb-3 text-center">
							<div v-for="plan in plans.plans" :key="plan.id" class="card mb-3 shadow-sm" v-show="plan.planType === 'Special' && payment.statusId === 'PS_CANCELLED'">
								<div v-show="plan.planType === 'Special'" class="ribbon-wrapper lg">
									<div class="ribbon green lg">
										SPECIAL!
									</div>
								</div>
								<div class="card-header">
									<div @click="planId = plan.id" class="btn btn-lg btn-block btn-primary" :class="{'active': planId === plan.id}"><h4 v-html="plan.title"></h4></div>
								</div>
								<div class="card-body">
									<div class="card-title pricing-card-title"><h1 v-html="plan.newPrice"></h1></div>
									<ul class="list-unstyled mt-3 mb-4">
										<li v-html="plan.description" class="text-center"></li>
										<li v-html="plan.access" class="text-center"></li>
										<li class="text-center">Free Mat/Towel Service</li>
									</ul>
								</div>

								<div v-show="originalPlanId === plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary"> Current Plan </el-button>
								</div>
								<div v-show="originalPlanId !== plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>

								<div v-show="planId === plan.id && payment.statusId === 'PS_CANCELLED'">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Purchase {{selectedPlanName}}!</el-button>
								</div>
							</div>

						</div>

					</div>
				</div>


				<div v-if="payment.statusId === 'PS_ACTIVE'">

					<div class="card mb-3">
						<div class="ribbon-wrapper">
							<div class="ribbon green">
								VALUE
							</div>
						</div>
						<div class="card-body">
							<h4 class="mb-0">
								Recurring Unlimited Memberships: Our 3 most popular plans!
							</h4>
						</div>


					</div>

					<div class="card-deck mb-3 text-center">
						<div v-for="plan in plans.plans" :key="plan.id" class="card mb-4 shadow-sm" v-show="plan.planType === 'Mem'">
							<div v-show="plan.id === '112988201'" class="ribbon-wrapper lg">
								<div class="ribbon green lg">
									SAVE 30%!
								</div>
							</div>
							<div class="card-header">
								<div @click="planId = plan.id" class="btn btn-lg btn-block btn-primary" :class="{'active': planId === plan.id}"><h4 v-html="plan.title"></h4></div>
							</div>
							<div class="card-body">
								<div class="card-title pricing-card-title"><h1 v-html="plan.newPrice"></h1></div>
								<ul class="list-unstyled mt-3 mb-4">
									<li v-html="plan.description" class="text-center"></li>
									<li v-html="plan.access" class="text-center"></li>
									<li class="text-center">Free Mat/Towel Service</li>
								</ul>
							</div>


							<div v-if="payment.statusId === 'PS_ACTIVE'">

								<div v-show="originalPlanId === plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary"> Current Plan </el-button>
								</div>
								<div v-show="originalPlanId !== plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>

								<div v-show="planId === plan.id && payment.statusId !== 'PS_CANCELLED'">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Switch to {{selectedPlanName}}!</el-button>
								</div>
							</div>

							<div v-if="payment.statusId === 'PS_CANCELLED'">
								<div v-show="originalPlanId === payment.productId  && payment.statusId === 'PS_CANCELLED' && originalPlanId === plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>
								<div v-show="originalPlanId !== plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>
								<div v-show="originalPlanId === plan.id  && planId === plan.id && payment.statusId === 'PS_CANCELLED'">
									<el-button class="mb-3 ml-3 mr-3" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Purchase {{selectedPlanName}}!</el-button>
								</div>
								<div v-show="planId === plan.id && payment.statusId === 'PS_CANCELLED' && originalPlanId !== plan.id ">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Purchase {{selectedPlanName}}!</el-button>
								</div>
							</div>

						</div>
					</div>


					<div class="card mb-3">
						<div class="card-body">
							<h4 class="mb-0">
								Recurring 4 class per Month Memberships: Great for less frequent users!
							</h4>
						</div>
					</div>

					<div class="card-deck mb-3 text-center">
						<div v-for="plan in plans.plans" :key="plan.id" class="card mb-4 shadow-sm" v-show="plan.planType === 'Mem2'">
							<div v-show="plan.id === '112988201'" class="ribbon-wrapper lg">
								<div class="ribbon green lg">
									SAVE 30%!
								</div>
							</div>
							<div class="card-header">
								<div @click="planId = plan.id" class="btn btn-lg btn-block btn-primary" :class="{'active': planId === plan.id}"><h4 v-html="plan.title"></h4></div>
							</div>
							<div class="card-body">
								<div class="card-title pricing-card-title"><h1 v-html="plan.newPrice"></h1></div>
								<ul class="list-unstyled mt-3 mb-4">
									<li v-html="plan.description" class="text-center"></li>
									<li v-html="plan.access" class="text-center"></li>
									<li class="text-center">Free Mat/Towel Service</li>
								</ul>
							</div>


							<div v-if="payment.statusId === 'PS_ACTIVE'">

								<div v-show="originalPlanId === plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary"> Current Plan </el-button>
								</div>
								<div v-show="originalPlanId !== plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>

								<div v-show="planId === plan.id && payment.statusId !== 'PS_CANCELLED'">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Switch to {{selectedPlanName}}!</el-button>
								</div>
							</div>

							<div v-if="payment.statusId === 'PS_CANCELLED'">
								<div v-show="originalPlanId === payment.productId  && payment.statusId === 'PS_CANCELLED' && originalPlanId === plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>
								<div v-show="originalPlanId !== plan.id && planId !== plan.id">
									<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
								</div>
								<div v-show="originalPlanId === plan.id  && planId === plan.id && payment.statusId === 'PS_CANCELLED'">
									<el-button class="mb-3 ml-3 mr-3" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Purchase {{selectedPlanName}}!</el-button>
								</div>
								<div v-show="planId === plan.id && payment.statusId === 'PS_CANCELLED' && originalPlanId !== plan.id ">
									<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" @click="submit" type="primary"> Purchase {{selectedPlanName}}!</el-button>
								</div>
							</div>

						</div>
					</div>

				</div>





				<div class="card mb-3" v-show="payment.statusId !== 'PS_ACTIVE'">
					<div class="card-body">
						<h3 class="mb-2">
							Non-Recurring Unlimited Passes
						</h3>
						<p class="mb-0">
							Unlimited access for a fixed time
						</p>
					</div>
				</div>

				<div class="card-deck mb-3 text-center">
					<div v-for="plan in plans.plans" :key="plan.id" class="card mb-4 shadow-sm" v-show="plan.planType === 'Pass' && payment.statusId !== 'PS_ACTIVE'">
						<div class="card-header">
							<div @click="planId = plan.id" class="btn btn-lg btn-block btn-primary" :class="{'active': planId === plan.id}"><h4 v-html="plan.title"></h4></div>
						</div>
						<div class="card-body">
							<div class="card-title pricing-card-title"><h1 v-html="plan.newPrice"></h1></div>
							<ul class="list-unstyled mt-3 mb-4">
								<li v-html="plan.description" class="text-center"></li>
								<li v-html="plan.access" class="text-center"></li>
								<li class="text-center">Free Mat/Towel Service</li>
							</ul>
						</div>
						<div v-show="planId === plan.id">
							<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" :loading="thinking.save" type="primary" @click="submit">Purchase {{selectedPlanName}}!</el-button>
						</div>
						<div v-show="originalPlanId !== plan.id && planId !== plan.id">
							<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
						</div>
					</div>
				</div>

				<div class="card mb-3" v-show="payment.statusId !== 'PS_ACTIVE'">
					<div class="card-body">
						<h3 class="mb-2">
							Class Cards
						</h3>
						<p class="mb-0">
							Best for occasional classes - good for 1 year
						</p>
					</div>
				</div>

				<div class="card-deck mb-3 text-center">
					<div v-for="plan in plans.plans" :key="plan.id" class="card mb-4 shadow-sm" v-show="plan.planType === 'Card' && payment.statusId !== 'PS_ACTIVE'">
						<div class="card-header">
							<div @click="planId = plan.id" class="btn btn-lg btn-block btn-primary" :class="{'active': planId === plan.id}"><h4 v-html="plan.title"></h4></div>
						</div>
						<div class="card-body">
							<div class="card-title pricing-card-title"><h1 v-html="plan.newPrice"></h1></div>
							<ul class="list-unstyled mt-3 mb-4">
								<li v-html="plan.description" class="text-center"></li>
								<li v-html="plan.access" class="text-center"></li>
								<li class="text-center">Free Mat/Towel Service</li>
							</ul>
						</div>
						<div v-show="planId === plan.id">
							<el-button class="mb-3 ml-3 mr-3" v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" :loading="thinking.save" type="primary" @click="submit">Purchase {{selectedPlanName}}!</el-button>
						</div>
						<div v-show="originalPlanId !== plan.id && planId !== plan.id">
							<el-button class="mb-3 ml-3 mr-3" type="primary" @click="planId = plan.id"> Select </el-button>
						</div>
					</div>
				</div>
			</template>

				<template v-else>
					<payment ref="payment" @back="planSelection = 'standard'" :selected-plan="selectedPlan" @payment="onPayment" />
				</template>



			</div>

		</div>

		<el-alert :title="serverError" v-if="serverError"
							type="error"
							effect="dark"
							show-icon
							:closable="false" class="mt-4">
		</el-alert>

		<div class="text-center" v-if="planSelection === 'standard' && payment.statusId !== 'PS_CANCELLED'">
			<a class="btn btn-lg btn-primary" style="cursor: pointer;text-decoration: none" @click="$emit('cancelMembership')">Cancel Membership</a>
		</div>

		<div v-if="selectedPlan && selectedPlan.planType === 'Mem' && payment.statusId !== 'PS_CANCELLED'">
			<span slot="footer" class="dialog-footer">
			<el-button v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" :loading="thinking.save" type="primary" @click="submit">Switch to {{selectedPlanName}}</el-button>
			</span>
		</div>

		<div v-else>
			<span slot="footer" class="dialog-footer">
				<el-button v-if="canConfirm" :disabled="payment.statusId === 'PS_ON_HOLD' && changeNow === null" :loading="thinking.save" type="primary" @click="submit">Purchase {{selectedPlanName}}</el-button>
			</span>
		</div>

	</el-dialog>
	

</template>

<script>
	import { mapGetters } from "vuex";
	import { rest } from "@/utilities/rest.js";
	import payment from "./payment/index.vue";
	export default {
		name: "membership-plan",
		data() {

			return {
				originalPlanId: null,
				planId: "",
				changeNow: null,
				thinking: {
					save: false
				},
				serverError: null,
				planSelection: "standard",
				message: '',
        numMonths: ''}
		},
		props: ["user"],
		components: {
			payment
    },
		created() {

		},

		mounted() {
			if (this.hasLegacy) {
        this.planId = this.plans.preSelect;
       // this.planId = this.payment.productId;
			} else {
				this.originalPlanId = this.payment.productId;
				this.planId = this.payment.productId;
			}
		},

		computed: {
			...mapGetters({
				modalWidth: "modalWidth",
        plans: "plans",
				payment: "payment",
				config: "membershipConfig"
			}),
			hasLegacy() {//"111138592"
				return this.plans.plans.filter((r) => {
					return r.id === this.payment.productId;
				}).length === 0;
			},
			canConfirm() {
				if (this.planId !== this.originalPlanId) {
					return true;
				} else {
          if (this.planId === this.originalPlanId && this.payment.statusId === 'PS_CANCELLED')
					return true;
				}
				return false;
			},
			selectedPlan() {
				return _.find(this.plans.plans, ["id", this.planId]);
			},

			calcPrice() {

				if (this.numMonths === '') {
					return '';
				} else if (this.numMonths > 0 && this.numMonths < 4) {
					return this.numMonths * 119 * .9;
				} else if (this.numMonths > 3 && this.numMonths < 7) {
					return this.numMonths * 119 * .8;
				} else {
					return this.numMonths * 119 * .7;
				}
      },

      calcDiscount() {

				if (this.numMonths === '') {
					return '';
				} else if (this.numMonths > 0 && this.numMonths < 4) {
					return '10%';
				} else if (this.numMonths > 3 && this.numMonths < 7) {
					return '20%';
				} else {
					return '30%';
				}
      },
      
			selectedPlanName() {
				if (this.canConfirm) {
					const regex = /(<([^>]+)>)/ig;
					let text = this.selectedPlan.title;
					return text.replace(regex, " ");
				} return null;
			}
		},
		methods: {
			selectPlan(id) {
				this.planId = id;
				this.$router.push({ name: 'profile' });
			},

      formatPrice(value) {
        let val = (value / 1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

			replaceTokens(row) {
				if (row.indexOf("Monthly price") > -1) {
					return "Monthly price";
				}
				return row;
			},

			determineActive(idx) {				
				var activeIdx = _.findIndex(this.plans.plans, { 'id': this.planId });
				return activeIdx === idx;
			},

			submit() {
				

				this.$validator.validateAll().then(valid => {

					if (valid) {

						

						if (this.selectedPlan.planType === "Mem" && this.payment.statusId !== "PS_CANCELLED") {

							this.thinking.save = true;

							let payload = {
								userId: this.user.userId,
								studioId: this.payment.studioId,
								productId: this.planId,
								//id: this.selectedPlan.id,
								//planType: this.selectPlan.planType || null,
								changeNow: this.payment.statusId === "PS_ON_HOLD" ? this.changeNow : false
							};

							rest.post("Account", "/ChangeMembership", "json", JSON.stringify(payload)).then(response => {
								setTimeout(() => {
									this.$message.success("Changes have been saved.");
								}, 1000);
								this.$emit("fetch", "payment");
								this.$parent.dialog.plan = false;
							}).fail((xhr) => {
								this.serverError = JSON.parse(xhr.responseText);
							}).always(() => {
								this.thinking.save = false;
							});
						} else {

							if (this.planSelection === "standard") {
                this.planSelection = "non-recurring";
							} else {
								// Payment data is visible, process it
								this.handlePaymentFormPayload();
              }			
            }
					}
				})		
			},

			handlePaymentFormPayload() {
				this.$refs.payment.submit();
			},

			onPayment(e) {
				
				const payload = {
					userId: this.user.userId,
					// studioId: this.payment.studioId,
          studioID: "935665",
					productId: this.planId,
					id: this.selectedPlan.id,
					planType: this.selectedPlan.planType || null,
					payment: JSON.stringify(e),
					changeNow: this.payment.statusId === "PS_ON_HOLD" ? this.changeNow : false
				};

        rest.post("Account", "/BuyAPass", "json", JSON.stringify(payload)).then(response => {
          setTimeout(() => {
            this.$message.success("Changes have been saved.");
          }, 1000);
          this.$emit("fetch", "payment");
          this.$parent.dialog.plan = false;
        }).fail((xhr) => {
          this.serverError = JSON.parse(xhr.responseText);
        }).always(() => {
          this.thinking.save = false;
				});

      }
		}
	}
</script>

<style scoped>

	.table th, .table td {
		border-bottom: 1px solid #dee2e6;
		border-top: 0;
	}

	table.table {
	}

		table.table tbody tr td:not(:first-child) {
			opacity: .5;
		}

		table.table tbody tr td.active {
			opacity: 1;
			color: #cc6600;
		}

		table.table thead tr th {
			border-top: 0;
		}

	.plan-selector {
		background: #cc6600;
		color: white;
		width: 80px;
		height: 80px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		line-height: 18px;
		opacity: .5;
		cursor: pointer;
		margin: auto;
		transition: all 0.3s;
	}

		.plan-selector.active {
			opacity: 1;
			position: relative;
		}

			.plan-selector.active::after {
				content: '';
				display: block;
				border: 0 solid transparent;
				border-top-color: #cc6600;
				position: absolute;
				top: 100%;
				left: 50%;
				-webkit-transform: translateX(-50%);
				-moz-transform: translateX(-50%);
				-ms-transform: translateX(-50%);
				-o-transform: translateX(-50%);
				transform: translateX(-50%);
				border-width: 10px;
				border-bottom-width: 0;
			}


	.list-enter,
	.list-leave-to {
		visibility: hidden;
		height: 0;
		margin: 0;
		padding: 0;
		opacity: 0;
	}

	.list-enter-active,
	.list-leave-active {
		transition: all 0.3s;
	}

	.intro-wrapper {
		max-width: 300px;
		margin: auto;
	}

	.checks {
		max-width: 300px;
		margin: auto; /*
		position: relative;
		left: 5px;*/
		display: flex;
		flex-direction: column;
	}

	.check {
		position: relative;
		display: flex;
		align-items: flex-start;
		font-size: 18px;
	}

		.check p {
			font-size: 16px;
			margin-bottom: 15px;
			color: #333;
		}

		.check i {
			position: relative;
			right: -5px;
			top: 5px;
		}
</style>
